module.exports = __webpack_public_path__ + "static/img/info-environment.5b0fa76e.png";